import req from 'utils/req';

export default {
  getDetailedOfferRequest: function (offerId) {
    return req(`${URL_API_HOST}/api/v2/messages/offer/${offerId}`).get();
  },
  sendMessage: function (to, message) {
    const data = {
      to: to,
      body: message,
    };
    return req(`${URL_API_HOST}/api/v1/messages`).post(data);
  },
  sendOfferRequest: function (request) {
    return req(`${URL_API_HOST}/api/v1/messages`).post(request);
  },
};
